
import React, { useContext } from "react";
import { GlobalContext } from '../../contexts/GlobalContext';
import './Footer.css'
import { Link } from "react-router-dom";
import socialMedias from '../../lists/socialMedias.json'
import getImage from "../../useFull/getImage";

const Footer = () => {
    getImage()
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const { footerItens, footer, footerTerms } = require(`../../assets/languages/${language}/footer.json`);
    return (
        <div className="footer-app-container">
            <div className="main-container bg-gray100">
                <div className="section-container">
                    <div className="footer-container">
                        <div className="footer-list-container">
                            {footerItens?.map((d, i) => {
                                return (

                                    <div className="footer-list-content" key={i}>
                                        <span className="mg-bot-30 line-wrap">{d.title}</span>
                                        {d?.itens?.map((e, ind) => {
                                            return (<Link to={e.value} key={ind}>{e.label}</Link>)
                                        })}
                                    </div>
                                )
                            })}
                        </div>
                        <div className="footer-social-container">
                            <div className="bg-icon footer-logo" style={{ backgroundImage: `url(${getImage('', 'logo-thumb.png')})` }}></div>
                            <div className="footer-social-icons-container">
                                {socialMedias?.map((d, i) => {
                                    return (
                                        <Link key={i} to={d.link} target="_blank" rel="noopener noreferrer">
                                            <div className={`bg-icon footer-social-icon ${i + 1 !== socialMedias.length && 'mg-r-30'}`} style={{ backgroundImage: `url(${getImage('social', d.iconName)})` }} />
                                        </Link>
                                    )
                                })}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="main-container bg-primary100">
                <div className="section-container">
                    <div className="footer-copyright-container">
                        <span className="white100">{`${footer} ${new Date().getFullYear()}`}</span>
                        <div className="footer-copyright-terms-container">
                            {footerTerms?.map((d, i) => {
                                return (<Link to={d.value} key={i} className={i + 1 < footerTerms.length ? 'mg-r-30' : ''}>{d.label}</Link>)
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer